import { useAppSelector } from "@3gaam/app/src/store/hooks";
import Icon from "@3gaam/shared/components/general/icon";
import { filterFalsy } from "@3gaam/shared/utils/filterFalsy";
import React from "react";

type NotificationItemProps = {
  show?: boolean;
  title?: string;
  sub?: string;
  icon?: string;
  onClick?: () => void;
};

const NotificationItem: React.FC<NotificationItemProps> = ({
  show,
  title,
  sub,
  icon,
  onClick,
}) => {
  return (
    <div
      className={`${
        show ? "notif-item__wrapper" : "notif-item__wrapper--hide"
      }`}
      onClick={() => {
        if (!!onClick) {
          onClick();
        }
      }}
    >
      <div className="notif-item__icon">
        {icon ? <Icon name={icon || ""} /> : "i"}
      </div>
      <div className="notif-item__content-wrapper">
        <p className="notif-item__content--bold">{title}</p>
        <p className="notif-item__content">{sub}</p>
      </div>
    </div>
  );
};

type NotificationProps = {};

const Notification: React.FC<NotificationProps> = () => {
  const messages = useAppSelector((state) => state.message.messages);

  return (
    <div className="notif__wrapper">
      {messages
        ?.filter((i) => i.showAsNotification)
        ?.filter(filterFalsy)
        ?.map((message, index) => (
          <NotificationItem
            key={index}
            show={true}
            title={message?.notification?.title}
            sub={message?.notification?.body}
            onClick={() => {
              if (message?.fcmOptions?.link) {
                window.location.href = message?.fcmOptions.link;
              }
            }}
          />
        ))}
    </div>
  );
};

export default React.memo(Notification);
